import React, {useEffect, useState} from "react";
import TextField from "@material-ui/core/TextField";
// import Autocomplete from "@material-ui/lab/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import API from "../../../helpers/apiHelpers";
import {Autocomplete} from "@material-ui/lab";

const FontsInput = (props) => {
    const [open, setOpen] = useState(false);
    const [options, setOptions] = useState([]);
    const loading = open && options.length === 0;

    useEffect(() => {
        let active = true;
        if (!loading) {
            return undefined;
        }
        (async () => {
            const list = await API.getFontsList();
            const fonts = list.items.filter(item => item.subsets.includes("latin")).
                map(item => item.family);
            if (active) {
                setOptions(fonts);
            }
        })();
        return () => {
            active = false;
        };
    }, [loading]);

    useEffect(() => {
        if (!open) {
            setOptions([]);
        }
    }, [open]);

    return (
        <Autocomplete
            open={open}
            onOpen={() => {
                setOpen(true);
            }}
            onClose={() => {
                setOpen(false);
            }}
            getOptionSelected={(option, value) => option === value}
            onChange = {(e, value) => props.onChange(value || "")}
            getOptionLabel={(option) => option}
            options={options}
            loading={loading}
            value={props.value}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Choose font"
                    variant="outlined"
                    InputProps={{
                        style:{ height: 48 },
                        ...params.InputProps,
                        endAdornment: (
                            <React.Fragment>
                                {loading ? <CircularProgress color="inherit" size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </React.Fragment>
                        ),
                    }}
                />
            )}
        />
    );
};

export default FontsInput;
